(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["world-order"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-id]').forEach((section) => {
    const variantId = section.querySelector('.wo__variant-id');
    const buttonPrice = section.querySelector('.wo__button-price');
    section.querySelectorAll('input[name="world-order-variant"]').forEach((input) => {
      input.addEventListener('change', () => {
        variantId.value = input.value;
        buttonPrice.textContent = input.dataset.price;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
